"use strict";
var React = require("react");
var Modal = require("react-bootstrap").Modal;
var closeButton = require("react-bootstrap").closeButton;
var Button = require("react-bootstrap").Button;
var ButtonToolbar = require("react-bootstrap").ButtonToolbar;
var InventoryActions = require("../../actions/InventoryActions");
var AuthStore = require("../../stores/AuthenticationStore");

var DeleteInventoryItemFormModal = React.createClass({
  getInitialState: function() {
    const userData = AuthStore.getState();
    let hasRole = false;
    if (!this.props.equipment) {
      hasRole = true;
    } else if (userData.roles) {
      for (let i = 0; i < userData.roles.length; i++) {
        if (userData.roles[i] === this.props.equipment) {
          hasRole = true;
        }
      }
    }
    return {
      hasRole: hasRole,
    }
  },
  componentDidMount() {
    AuthStore.listen(this.onChange);
  },
  componentWillUnmount() {
    AuthStore.unlisten(this.onChange);
  },
  onChange: function() {
    this.setState(this.getInitialState());
  },
  onSubmit(event) {
    event.preventDefault();
    InventoryActions.deleteItem(this.props.equipment.id);
    this.props.onHide();
  },
  render: function() {
    return (
      <Modal {...this.props} bsStyle="primary" animation={true}>
        <Modal.Body>
          <div id="deleteInventoryItemModal" className="modal-body">
            <h3> Ertu viss um að þú viljir eyða: {this.props.equipment.name}? </h3>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <Button className="btn-danger" onClick={this.onSubmit} type="submit">Já</Button>
            <Button onClick={this.props.onHide}>Nei</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
});

module.exports = DeleteInventoryItemFormModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/DeleteInventoryItemFormModal.js